import { createContext } from 'react';
import { createBatcher } from '../components/AnimateSharedLayout/utils/batcher.js';
var SharedLayoutContext = /*#__PURE__*/createContext(createBatcher());
/**
 * @internal
 */
var FramerTreeLayoutContext = /*#__PURE__*/createContext(createBatcher());
function isSharedLayout(context) {
  return !!context.forceUpdate;
}
export { FramerTreeLayoutContext, SharedLayoutContext, isSharedLayout };